import React from 'react';
import { X, Printer } from 'lucide-react';
import { PaymentMethod } from '../../types/index';
import { traduzirMetodoPagamento } from '../../shared/logica/pagamentos';

function MetodoToggle({ value, label, selected, onToggle }) {
  return (
    <button
      type="button"
      onClick={() => onToggle(value)}
      className={`px-3 py-1.5 rounded-xl text-[10px] font-black uppercase transition-all border ${
        selected
          ? 'bg-blue-100 text-blue-800 border-blue-200'
          : 'bg-slate-50 text-slate-400 border-slate-100'
      }`}
    >
      {label}
    </button>
  );
}

export default function ModalImprimirMovimentos({
  isOpen,
  onClose,
  title = 'Imprimir Movimentos',
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
  selectedMethods,
  onToggleMethod,
  previewCount,
  previewTotal,
  onPrint
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-slate-900/70 backdrop-blur-md z-[110] flex items-center justify-center p-4">
      <div className="bg-white rounded-[2.5rem] w-full max-w-xl shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-green-700 to-emerald-700 text-white p-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <Printer size={22} className="text-white" />
              <h2 className="text-2xl font-black">{title}</h2>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-full bg-white/20 hover:bg-white/30 transition-colors"
              aria-label="Fechar"
            >
              <X size={20} />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="p-6 space-y-6" style={{ colorScheme: 'light' }}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">
                De
              </label>
              <input
                type="date"
                value={fromDate}
                onChange={(e) => onFromDateChange(e.target.value)}
                className="w-full px-4 py-3 rounded-2xl border-2 border-slate-100 font-bold outline-none focus:border-green-500 bg-white text-slate-900"
                style={{ colorScheme: 'light' }}
              />
            </div>
            <div>
              <label className="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">
                Até
              </label>
              <input
                type="date"
                value={toDate}
                onChange={(e) => onToDateChange(e.target.value)}
                className="w-full px-4 py-3 rounded-2xl border-2 border-slate-100 font-bold outline-none focus:border-green-500 bg-white text-slate-900"
                style={{ colorScheme: 'light' }}
              />
            </div>
          </div>

          <div>
            <p className="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">
              Método de pagamento (opcional)
            </p>
            <div className="flex flex-wrap gap-2">
              {[
                PaymentMethod.CASH,
                PaymentMethod.CARD,
                PaymentMethod.TRANSFER,
                PaymentMethod.CHEQUE,
                PaymentMethod.MBWAY,
                PaymentMethod.VOUCHER,
                PaymentMethod.PENDING
              ].map((m) => (
                <MetodoToggle
                  key={m}
                  value={m}
                  label={traduzirMetodoPagamento(m)}
                  selected={selectedMethods.includes(m)}
                  onToggle={onToggleMethod}
                />
              ))}
            </div>
            <p className="text-xs text-slate-400 font-bold mt-3">
              Pré-visualização: <span className="text-slate-700">{previewCount}</span> movimentos ·{' '}
              <span className="text-slate-700">{(previewTotal || 0).toFixed(2)}€</span>
            </p>
          </div>

          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 py-4 rounded-2xl font-black bg-slate-100 text-slate-600 hover:bg-slate-200 transition-colors"
            >
              Cancelar
            </button>
            <button
              onClick={onPrint}
              className="flex-1 py-4 rounded-2xl font-black text-white bg-green-700 hover:bg-green-800 transition-colors shadow-lg disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={previewCount === 0}
              title={previewCount === 0 ? 'Sem movimentos para imprimir com estes filtros' : 'Imprimir'}
            >
              Imprimir
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


